import { z } from 'zod';
import { PseudonymSchema } from './common';

/* POST /api/blocks — block whoever is behind a pseudoId / thread. */
export const CreateBlockSchema = z.object({
  /** One of these identifies the person to block. */
  pseudoId: z.string().optional(),
  threadId: z.string().optional(),
});
export type CreateBlock = z.infer<typeof CreateBlockSchema>;

export const BlockedEntrySchema = z.object({
  id: z.string(),
  pseudonym: PseudonymSchema,
  context: z.string().max(80),
  createdAt: z.iso.datetime(),
});
export type BlockedEntry = z.infer<typeof BlockedEntrySchema>;

/* GET /api/blocks */
export const BlockListResponseSchema = z.object({ blocks: z.array(BlockedEntrySchema) });
export type BlockListResponse = z.infer<typeof BlockListResponseSchema>;
